import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import hubUserService from "services/hubUserService";

// List HubDelivery
export const useListHubUser = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["hubDeliveries", params?.page, params?.columnFilter["filter[hub_id]"]],
    () => hubUserService.listHubUser(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("hubUser"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          meta_data: data._meta,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

// Create HubUser
export const useCreateHubUser = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubUserService.createHubUser, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("hubUser"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("hubUser"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Detail HubUser
export const useDetailHubUser = (payload, onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useQuery(
    ["hubUser", "detail"],
    () => hubUserService.detailHubUser(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.detail", {
                target: t("hubUser"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

// Update HubUser
export const useUpdateHubUser = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubUserService.updateHubUser, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("hubUser"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("hubUser"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Delete HubUser
export const useDeleteHubUser = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubUserService.deleteHubUser, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.remove", {
          target: t("title.user"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.remove", {
              target: t("title.user"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
